<template>
  <div class="px-4">
    <dynamic-zone-renderer v-if="content" :components="content.components" :add-paddings="false"/>

    <slot name="unlock-prompt"/>
    <ProgressChecker type="companionship" id="0" :has-prev="hasPrev" :has-next="hasNext" @nextSection="$emit('nextSection')"/>
  </div>
 </template>

<script>

import DynamicZoneRenderer from "../../renderer/DynamicZoneRenderer";
import AnalysisQueryMixin from "../../../mixins/AnalysisQueryMixin";
import ProgressChecker from "@/components/charts/analysis/progress/ProgressChecker.vue";

export default{
  mixins: [AnalysisQueryMixin],
  components: {ProgressChecker, DynamicZoneRenderer},
  data(){
    return{
      audioKey: 0,
      tab: 0,
      content: null,
    }
  },

  created(){
    this.getConnectionIntroduction();
  },

  methods:{
    getConnectionIntroduction(){
      let url = '/analysis/introductions/introduction.partnership-analysis'
      this.getContent('content', url);
    },
  }
}
</script>